import React, { useState } from 'react';
import './style.less';
import { SettingAPI } from '../../../../requests'
import { message } from 'antd';

const clsPrefix = 'cn-unbound-domain'
interface UnboundDomainProps {
  packageType?:string,
  siteId?:string,
  execute?: () => void,
}

const UnboundDomain: React.FC<UnboundDomainProps> = ({
  packageType = '',
  siteId,
  execute,
})=> {
  const [domain, setDomain] = useState<string>()

  async function handleBindClick() {
    const data:any = await SettingAPI.bindDomain({"site_id":siteId, private_domain: domain})
    if(data && data.ret !== 0) {
      message.config({
        top: 100
      })
      message.warning(data.msg)
    }
    execute && execute()
  }

  return (
    <div className={clsPrefix}>
      <div className={`${clsPrefix}__step-wrap`}>
        <label>步骤一&nbsp;&nbsp;&nbsp;腾讯云接入备案</label>
        <div className={`${clsPrefix}__step-contain`}>
            <span style={{color:'red'}}>重要: </span>
            <a href="//wiki.kuaizhan.com/pub/%E5%BF%AB%E7%AB%99%E8%A7%84%E5%88%99/%E5%85%AC%E7%A4%BA%E9%80%9A%E7%9F%A5/%E8%85%BE%E8%AE%AF%E4%BA%91%E6%8E%A5%E5%85%A5%E5%A4%87%E6%A1%88%E5%85%AC%E5%91%8A" target="_blank">腾讯云接入备案公告</a>
        </div>
      </div>
      <div className={`${clsPrefix}__step-wrap`}>
          <label>步骤二&nbsp;&nbsp;&nbsp;配置CNAME</label>
          <div className={`${clsPrefix}__step-contain`}>
              在域名服务网站上添加CNAME记录指向domain.cdn.dnsv1.com
              <a href="//wiki.kuaizhan.com/pub/%E5%8A%9F%E8%83%BD%E8%AF%A6%E8%A7%A3/%E8%AE%BE%E7%BD%AE/%E7%BB%91%E5%AE%9A%E7%8B%AC%E7%AB%8B%E5%9F%9F%E5%90%8D" className="link" target="_blank">如何配置域名CNAME</a>
              <br/>
              (其中domain指的是自己的独立域名，举例：m.kuaizhan.com.cdn.dnsv1.com，一般需要1-4小时生效)
          </div>
      </div>
      <div className={`${clsPrefix}__step-wrap`}>
        <label>步骤三&nbsp;&nbsp;&nbsp;输入独立域名</label>
        <div className={`${clsPrefix}__step-contain`}>
            <input type="text" value={domain} onChange={e => setDomain(e.target.value)} placeholder="例如：m.xxx.com" />
            {(packageType === "SITE_EXCLUSIVE")? (
              <input className="confirm" type="submit" onClick={handleBindClick} value="绑定"></input>
            ):(
              <a className="upgrade" href="/homepage/pricing" target="_blank">立即升级</a>
            )}
        </div>
      </div>
      <div className={`${clsPrefix}__tip`}>
          <p><span>提示</span>
              {` `}独立域名需要备案
          </p>
      </div>
    </div>
  )
}

export default UnboundDomain;